import { useRef, useState } from "react";
import { InterviewSession, Question, QuestionAnswers } from "../../Interface/Index";

export function useInterviewRoundsState() {
  // State to track the current interview session
  const [currentSession, setCurrentSession] = useState<InterviewSession | null>(null);
  const [currentSessionQuestions, setCurrentSessionQuestions] = useState<Question[]>([]);
  const [currentSessionQuestionAnswers, setCurrentSessionQuestionAnswers] = useState<QuestionAnswers[]>([]);

  // State to track round completion
  const [isRoundFinished, setIsRoundFinished] = useState<boolean>(false);

  // States to track proctoring logic
  const [showExitConfirmation, setShowExitConfirmation] = useState<boolean>(false);
  const [exitTimer, setExitTimer] = useState<boolean>(false);
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false);
  const [isVisibilityActive, setIsVisibilityActive] = useState<boolean>(true);

  // Other states
  const [showRetryEvaluation, setShowRetryEvaluation] = useState<boolean>(false);
  const [activeQuestionIndex, setActiveQuestionIndex] = useState<number>(-1);
  const [showCamRecorder, setShowCamRecorder] = useState<boolean>(false);
  const [showCameraConfirmation, setShowCameraConfirmation] = useState<boolean>(false);

  // Refs for tarcking fullscreen
  const elementRef: any = useRef(null);

  return {
    currentSession,
    setCurrentSession,
    currentSessionQuestions,
    setCurrentSessionQuestions,
    currentSessionQuestionAnswers,
    setCurrentSessionQuestionAnswers,
    isRoundFinished,
    setIsRoundFinished,
    showExitConfirmation,
    setShowExitConfirmation,
    exitTimer,
    setExitTimer,
    isFullscreen,
    setIsFullscreen,
    isVisibilityActive,
    setIsVisibilityActive,
    showRetryEvaluation,
    setShowRetryEvaluation,
    activeQuestionIndex,
    setActiveQuestionIndex,
    showCamRecorder,
    setShowCamRecorder,
    showCameraConfirmation,
    setShowCameraConfirmation,
    elementRef,
  };
}
